<template>
  <div class="py-4 container-fluid">
    <div class="custom-header font-weight-bold text-left">
      <div class="row">
        <div class="col-md-4">
          <div class="row">
            <div class="col">
              <label>Crew List</label>
            </div>
            <div class="col" v-if="isSystemAdmin">
              <button class="btn btn-sm btn-primary"
                      data-toggle="modal"
                      data-target="#adding-crew-modal"
                      data-backdrop="static"
                      data-keyboard="false">
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-4">
      <div class="card-header pb-1">
        <div class="row mt-2">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-md-8" style="padding-right: 105px">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                          <i class="fa fa-search pr-2"></i>By : {{ key }}
                        </button>

                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" @click="setKey('all')"
                             :class="{'active':searchKey == 'all'}">All</a>
                          <a class="dropdown-item" href="#" @click="setKey('first_name')"
                             :class="{'active':searchKey == 'first_name'}">FirstName</a>
                          <a class="dropdown-item" href="#" @click="setKey('middle_name')"
                             :class="{'active':searchKey == 'middle_name'}">MiddleName</a>
                          <a class="dropdown-item" href="#" @click="setKey('last_name')"
                             :class="{'active':searchKey == 'last_name'}">LastName</a>
                          <a class="dropdown-item" href="#" @click="setKey('rank')"
                             :class="{'active':searchKey == 'rank'}">Rank</a>
                          <a class="dropdown-item" href="#" @click="setKey('crewipn')"
                             :class="{'active':searchKey == 'crewipn'}">CrewIPN</a>
                          <!--  <a class="dropdown-item" href="#" @click="setKey('rank')" :class="{'active':searchKey == 'rank'}">Rank</a>  -->
                        </div>
                      </div>

                      <input type="text"
                             class="form-control small"
                             style="margin-right: 12px"
                             aria-label="Text input with dropdown button"
                             v-model="searchValue"
                             v-on:input="searchCrew(1)"
                             :placeholder="keyPlaceHolder">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-auto">
                <!--                                <div class="text-center font-weight-bold">-->
                <!--                                    {{`${pagination.from} - ${pagination.to}  of ${pagination.total}`}}-->
                <!--                                </div>-->
              </div>

              <div class="col col-lg-2">
                <select class="custom-select float-right" style="width: 204px" id="displayCounts" v-model="displayCount"
                        v-on:change="setRecords">
                  <option v-for="count in displayCounts" :key="count" :value="count" :selected="count === displayCount">
                    {{ count }} records
                  </option>
                </select>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="card-body fs-13px">
        <div class="text-left">
          <small> {{ `${pagination.from} - ${pagination.to} of ${pagination.total}` }}</small>
        </div>
        <nav aria-label="..." class="pt-0">
          <ul class="pagination pagination-sm">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">
                <font-awesome-icon icon="step-backward"/>
                First
              </button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item"
                :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setPage(pagination.lastPage)">
                Last
                <font-awesome-icon icon="step-forward"/>
              </button>
            </li>
          </ul>
        </nav>
        <div class="table-responsive-lg">
          <table class="table table-bordered" width="100%" cellspacing="0">
            <thead>
            <tr>
              <th scope="col" class="p-1 index-col-w align-middle" style="width: 2%!important;">#</th>
              <th scope="col" class="p-1 align-middle" style="width: 5%!important;">Rank</th>
              <th scope="col" class="p-1 align-middle" style="width: 7%!important;">Applicant No.</th>
              <th scope="col" class="p-1 align-middle" style="width: 7%!important;">Crew Code</th>
              <th scope="col" class="p-1 align-middle" style="width: 7%!important;">Crew IPN</th>
              <th scope="col" class="p-1 align-middle" style="width:15%!important;">First Name</th>
              <th scope="col" class="p-1 align-middle" style="width: 15%!important;">Middle Name</th>
              <th scope="col" class="p-1 align-middle" style="width: 15%!important;">Last Name</th>
              <th scope="col" class="p-1 align-middle" style="width: 5%!important;">Suffix</th>
              <th scope="col" class="p-1 align-middle" style="width: 7%!important;">Birthdate</th>
              <th scope="col" class="p-1 align-middle" style="width: 5%!important;">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(crew,index) in crews" :key="crew.id">
              <th scope="row" class="p-1 align-middle">{{ index + pagination.from }}</th>
              <td class="p-1 align-middle">{{ crew.rank }}</td>
              <td class="p-1 align-middle">{{ crew.applicantno }}</td>
              <td class="p-1 align-middle">{{ crew.crew_code }}</td>
              <td class="p-1 align-middle">{{ crew.crew_ipn }}</td>
              <td class="p-1 text-left pl-3 align-middle">{{ crew.firstname }}</td>
              <td class="p-1 text-left pl-3 align-middle">{{ crew.middlename }}</td>
              <td class="p-1 text-left pl-3 align-middle">{{ crew.lastname }}</td>
              <td class="p-1 text-left pl-3 align-middle">{{ crew.suffix }}</td>
              <td class="p-1 align-middle">{{ crew.birthdate }}</td>
              <td class="p-1 align-middle btn-view-container">
                <button class="btn btn-xsm tnkc-primary" @click="viewProfile(crew.id)">
                  <font-awesome-icon icon="eye"/>
                  View
                </button>
              </td>
              <!--                          <td class="p-1 align-middle btn-check-container">-->
              <!--                            <button v-if="crew.hasMedCert" type="button" class="btn btn-sm bg-rsv mr-2" data-toggle="modal" data-target="#reservation">-->
              <!--                              <font-awesome-icon icon="bookmark"/>-->
              <!--                              Rsrv-->
              <!--                            </button>-->
              <!--                            <button v-if="crew.hasMedCert" type="button" class="btn btn-sm bg-doc" data-toggle="tooltip" data-placement="top" title="View Covid19 MedicalCert">-->
              <!--                              <font-awesome-icon icon="file"/>-->
              <!--                              View-->
              <!--                            </button>-->
              <!--                            <button v-if="!crew.hasMedCert" type="button" class="btn btn-sm btn-light mr-2 border" data-toggle="modal" :data-target="'#file_upload'+crew.id" data-backdrop="static" data-keyboard="false">-->
              <!--                              <font-awesome-icon icon="file-upload"/>-->
              <!--                              Upload-->
              <!--                            </button>-->
              <!--                          </td>-->
              <!-- modal -->
              <cov-med-cert-file-upload :crew_id="crew.id" :count="displayCount"></cov-med-cert-file-upload>

            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade text-left" id="reservation" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Reserve Crew Booking</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group row">
                <label for="name" class="col-sm-2 mr-0 pr-0 col-form-label">Name:</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control bg-white border-0"
                         id="name" value="BOMPAT, ERWIN ESTOQUE" disabled>
                </div>
                <label for="rank" class="col-sm-2 mr-0 pr-0 col-form-label">Rank:</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control bg-white border-0"
                         id="rank" value="A/B (ABLE SEAMAN)" disabled>
                </div>
                <label for="contactNum" class="col-sm-2 mr-0 pr-0 col-form-label">Contact
                  Number:</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control bg-white border-0"
                         id="contactNum" value="+6394773157777" disabled>
                </div>
              </div>
              <div class="form-group row">
                <label for="checkIn" class="col-sm-2 mr-0 pr-0 col-form-label">Check In:</label>
                <div class="col-sm-4">
                  <input type="date" class="form-control"
                         id="checkIn">
                </div>
                <label for="checkOut" class="col-sm-2 text-right mr-0 pr-0 col-form-label">Check Out:</label>
                <div class="col-sm-4">
                  <input type="date" class="form-control"
                         id="checkOut">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-2">Purpose:</div>
                <div class="col-sm-10">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="preEmbark">
                    <label class="form-check-label" for="preEmbark">
                      PRE-EMBARKATION TRAINING
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="final">
                    <label class="form-check-label" for="final">
                      FINAL BRIEFING AND DISPATCH
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="documentation">
                    <label class="form-check-label" for="documentation">
                      DOCUMENTATION
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="debriefing">
                    <label class="form-check-label" for="debriefing">
                      DEBRIEFING
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="medical">
                    <label class="form-check-label" for="medical">
                      MEDICAL
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="jiss">
                    <label class="form-check-label" for="jiss">
                      JAPAN INTERNATIONAL SHIP's SYSTEM (JISS)
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="pni">
                    <label class="form-check-label" for="pni">
                      PROTECTION AND INDEMNITY (PNI)
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="others">
                    <label class="form-check-label" for="others">
                      OTHERS, PLEASE SPECIFY
                    </label>
                  </div>
                </div>
              </div>
              <!-- todo magbbase sa selected tnkc yung room then magbbase sa room yung bed
                    yellow if may tao pero pwede pa magddagdag,
                    red if puno na or di na pwede magdagdag or mappunta sa reserve list
               -->
              <div class="form-group row">
                <label for="floor" class="col-sm-2 mr-0 pr-0 col-form-label">Floor</label>
                <div class="col-sm-2">
                  <select class="form-control" id="floor">
                    <option>---</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                </div>
                <label for="room" class="col-sm-1 mr-0 pr-0 col-form-label">Room</label>
                <div class="col-sm-2">
                  <select class="form-control" id="room">
                    <option>---</option>
                    <option class="bg-danger text-white">201</option>
                    <option>202</option>
                    <option class="bg-danger text-white">203</option>
                    <option>204</option>
                    <option>205</option>
                    <option class="bg-warning">206</option>
                    <option class="bg-warning">207</option>
                    <option class="bg-warning">208</option>
                    <option>209</option>
                    <option class="bg-danger text-white">210</option>
                  </select>
                </div>
                <label for="bed" class="col-sm-1 mr-0 pr-0 col-form-label">Bed</label>
                <div class="col-sm-2">
                  <select class="form-control" id="bed">
                    <option>---</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="remarks" class="col-sm-2 mr-0 pr-0 col-form-label">Remarks:</label>
                <div class="col-sm-10">
                  <textarea class="form-control" id="remarks" rows="3"></textarea>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn tnkc-primary" data-dismiss="modal">
              <font-awesome-icon icon="save"/>
              Reserve
            </button>

            <button type="button" class="btn tnkc-secondary" data-dismiss="modal">
              <font-awesome-icon icon="times"/>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade text-left" id="adding-crew-modal" tabindex="-1" role="dialog"
         aria-labelledby="adding-crew-modal-label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" style="height: 50% !important;" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">New Crew record</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetNewCrew">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!--  crew application -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold">Applicant #No.</label>
              <span class="col-form-label">:</span>
              <div class="col-md-7">
                <input type="text" class="form-control form-control-sm" v-model="newCrew.applicantNo">
              </div>
            </div>

            <!--  crew code -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold">Crew Code</label>
              <span class="col-form-label">:</span>
              <div class="col-md-7">
                <input type="text" class="form-control form-control-sm"  v-model="newCrew.code">
              </div>
            </div>

            <!-- crew ipn -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold">Crew ipn</label>
              <span class="col-form-label">:</span>
              <div class="col-sm-7">
                <input type="text" class="form-control form-control-sm" required v-model="newCrew.ipn">
              </div>
            </div>

            <!-- First name           -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold"><sup class="text-danger">*</sup>First Name</label>
              <span class="col-form-label">:</span>
              <div class="col-sm-7">
                <input type="text" class="form-control form-control-sm" name="newCrewFirstName" id="new-crew-fname" required v-model="newCrew.firstName">
              </div>
            </div>

            <!-- Middle name   -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold"><sup class="text-danger">*</sup>Middle Name</label>
              <span class="col-form-label">:</span>
              <div class="col-sm-7">
                <input type="text" class="form-control form-control-sm" name="newCrewMiddleName" id="new-crew-mname" required v-model="newCrew.middleName">
              </div>
            </div>

            <!-- Last Name -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold"><sup class="text-danger">*</sup>Last Name</label>
              <span class="col-form-label">:</span>
              <div class="col-sm-7">
                <input type="text" class="form-control form-control-sm" name="newCrewLastName" id="new-crew-lname" required v-model="newCrew.lastName">
              </div>
            </div>

            <!-- suffix -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold">Suffix</label>
              <span class="col-form-label">:</span>
              <div class="col-sm-7">
                <input type="text" class="form-control form-control-sm" name="newCrewSuffix" id="new-crew-suffix" v-model="newCrew.suffix">
              </div>
            </div>

            <!-- rank -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold"><sup class="text-danger">*</sup>Rank</label>
              <span class="col-form-label">:</span>
              <div class="col-sm-7">
                <select name="newCrewRank" id="new-crew-rank" class="form-control form-control-sm" required v-model="newCrew.rankId">
                  <option class="text-center align-middle" :value=null>-- N / A --</option>
                  <option class="text-center align-middle" :value="rank.id" v-for="(rank,index) in objRanks" :key="rank.id">{{rank.alias.toUpperCase()}}</option>
                </select>
              </div>
            </div>

            <!-- gender -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold"><sup class="text-danger">*</sup>Gender</label>
              <span class="col-form-label">:</span>
              <div class="col-sm-7">
                <select name="newCrewGender" id="new-crew-gender" class="form-control form-control-sm" v-model="newCrew.gender">
                  <option :value=1>M</option>
                  <option :value=2>F</option>
                </select>
              </div>
            </div>

            <!-- birthdate -->
            <div class="form-group row justify-content-center">
              <label class="col-md-3 col-form-label font-weight-bold"><sup class="text-danger">*</sup>Birthdate</label>
              <span>:</span>
              <div class="col-md-7">
                <input type="date" class="form-control form-control-sm" required v-model="newCrew.birthdate">
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="createNewCrew">Save</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="resetNewCrew">Cancel</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { alertMixins } from '../../mixins/alertMixins'
import $ from 'jquery'
import CovMedCertFileUpload from './_modals/covMedCertFile_upload'
import { appMixins } from '@/mixins/app.mixins'

export default {
  name: 'CrewList',
  mixins: [alertMixins, appMixins],
  components: {
    CovMedCertFileUpload
  },
  data () {
    return {
      displayCount: 10,
      displayCounts: [10, 15, 20, 50, 100, 200],
      searchKey: 'all', // default
      searchValue: '',
      setActiveKey: '',
      key: '',
      keyPlaceHolder: ''
    }
  },
  methods: {
    ...mapActions([
      'getCrewList',
      'sendEmailCrewReservation',
      'setPaginationNull',
      'create_new_crew',
      'reset_new_crew'
    ]),

    searchCrew (initializePage = null) {
      const page = (initializePage) || this.pagination.currentPage
      const params = {
        page: page,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        count: this.displayCount
      }
      this.getCrewList(params)
    },

    setKey (obj) {
      this.searchKey = obj
      this.searchBy()
      this.searchCrew()
    },

    setPage (page) {
      this.pagination.currentPage = page
      this.searchCrew()
    },

    setRecords (e) {
      this.displayCount = parseInt(e.target.value, 10)
      this.searchCrew()
    },

    searchBy () {
      switch (this.searchKey) {
        case 'all':
          this.key = 'All'
          this.keyPlaceHolder = 'Search here ...'
          break

        case 'last_name':
          this.key = 'LastName'
          this.keyPlaceHolder = 'Search Last Name here ...'
          break

        case 'first_name':
          this.key = 'FirstName'
          this.keyPlaceHolder = 'Search First Name here ...'
          break

        case 'middle_name':
          this.key = 'MiddleName'
          this.keyPlaceHolder = 'Search Middle Name here ...'
          break

        case 'crewipn':
          this.key = 'CrewIPN'
          this.keyPlaceHolder = 'Search CrewIPN here ...'
          break

        case 'rank':
          this.key = 'Rank'
          this.keyPlaceHolder = 'Search CrewRank here ...'
          break
      }
    },

    viewProfile (crewId) {
      this.$router.push({ name: 'CrewProfile', params: { id: crewId } })
    },

    // create_new_crew
    async createNewCrew () {
      if (await this.questionAlert('Are you sure you want to save this details')) {
        this.create_new_crew(this.newCrew)
          .then((r) => {
            if (r) {
              this.$nextTick(() => {
                this.successAlert('Creating new crew record successfully', 'Creating Record')
                this.searchCrew()
              })
            }
          })
      }
    },

    resetNewCrew () {
      this.reset_new_crew()
    }
  },

  computed: {
    ...mapGetters(['crews', 'pagination', 'newCrew', 'objRanks']),

    paginationPages () {
      const pages = []
      const currentPage = this.pagination.currentPage
      const lastPage = this.pagination.lastPage
      if (lastPage > 1) {
        let initialLimit = 1
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i)
          if (i >= lastPage) {
            break
          }
        }
      }
      return pages
    }
  },

  created () {
    if (!this.crews.length && !this.pagination.length) {
      this.searchCrew()
    }
    this.searchBy()
  },

  mounted () {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  },

  beforeDestroy () {
    // this.setPaginationNull();
  },

  beforeMount () {
    this.searchCrew()
  }

}
</script>

<style scoped>
.btn-xsm, .btn-group-xsm > .btn {
  padding: 0.20rem 0.2rem !important;
  font-size: 0.870rem !important;
  line-height: 1 !important;
  border-radius: 0.25rem !important;
}

.btn-view-container {
  text-align: center;
  width: 120px;
  border-right: 0px solid;
}

.btn-check-container {
  text-align: left;
  width: 130px;
  border-left: 0px solid;
  border-right: 0px solid;
}

.fs-13px {
  font-size: 13px;
}
</style>
